var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/InclusionStatus.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { Id } from '../Id';
import { Version } from '../Version';
import { SortBy, SortOrder } from '../Sort';
import { ApiDomain } from '../domain';
export var InclusionStatus;

(function (_InclusionStatus) {
  var domain = ApiDomain.domain('ElementPathClassifier', {
    name: "domain",
    sid: "-8klfsa"
  });
  var InclusionBimModelType = _InclusionStatus.InclusionBimModelType = t.union([t.literal('BimModel'), t.literal('BimCategory'), t.literal('BimFamily'), t.literal('BimStandardSize'), t.literal('BimElement')], 'InclusionBimModelType');
  var InclusionUserClassifierGroupType = _InclusionStatus.InclusionUserClassifierGroupType = t.literal('UserClassifierGroup', 'InclusionUserClassifierGroupType');
  var InclusionUserClassifierType = _InclusionStatus.InclusionUserClassifierType = t.literal('UserClassifier', 'InclusionUserClassifierType');
  var InclusionValue = _InclusionStatus.InclusionValue = t.union([t.literal('PARENT_INCLUDED'), t.literal('SELF_INCLUDED'), t.literal('CHILDREN_INCLUDED')], 'InclusionValue');
  var io = _InclusionStatus.io = t.type({
    itemId: Id,
    itemType: t.union([InclusionBimModelType, InclusionUserClassifierGroupType, InclusionUserClassifierType]),
    value: InclusionValue
  }, 'InclusionStatus');
  var Response = _InclusionStatus.Response = t.type({
    result: t.readonlyArray(InclusionStatus.io)
  }, 'InclusionStatusResponse');
  var SourceClassifierType = _InclusionStatus.SourceClassifierType = t.union([t.literal('UserClassifier'), t.literal('BaseClassifier')], 'InclusionStatusSourceClassifierType');
  var RequestUserClassifierGroupItem = _InclusionStatus.RequestUserClassifierGroupItem = t.intersection([t.type({
    id: Id,
    type: InclusionUserClassifierGroupType
  }), t.partial({
    offset: t.number,
    limit: t.number,
    sortBy: t.number,
    sortOrder: t.number
  })], 'InclusionStatusRequestUserClassifierGroupItem');
  var RequestUserClassifierItem = _InclusionStatus.RequestUserClassifierItem = t.intersection([t.type({
    id: Id,
    type: InclusionUserClassifierType
  }), t.partial({
    offset: t.number,
    limit: t.number,
    sortBy: SortBy,
    sortOrder: SortOrder
  })], 'InclusionStatusRequestUserClassifierItem');
  var RequestBimModelItem = _InclusionStatus.RequestBimModelItem = t.intersection([t.type({
    id: Id,
    modelVersion: Version,
    type: InclusionBimModelType
  }), t.partial({
    offset: t.number,
    limit: t.number,
    sortBy: t.number,
    sortOrder: t.number
  })], 'InclusionStatusRequestBimModelItem');
  var RequestItems = _InclusionStatus.RequestItems = t.type({
    classifierId: Id,
    classifierVersion: Version,
    sourceClassifierId: Id,
    sourceClassifierVersion: Version,
    items: t.type({
      singleRequest: t.union([t["null"], t.array(t.union([RequestUserClassifierGroupItem, RequestBimModelItem, RequestUserClassifierItem]))]),
      bulkRequest: t.union([t["null"], t.array(t.union([RequestUserClassifierGroupItem, RequestBimModelItem, RequestUserClassifierItem]))])
    })
  }, 'InclusionStatusRequestItems');
  var calculate = _InclusionStatus.calculate = ApiCallService.create({
    name: 'calculate',
    parentDomain: domain,
    getKey: ['classifierId', 'classifierVersion'],
    result: Response
  });
  var calculateStandardSize = _InclusionStatus.calculateStandardSize = ApiCallService.create({
    name: 'calculateStandardSize',
    parentDomain: domain,
    getKey: ['classifierId', 'classifierVersion', 'modelVersion', 'standardSizeId'],
    result: Response
  });
})(InclusionStatus || (InclusionStatus = {}));